module.exports = __webpack_public_path__ + "14f4a6dd897ffb8e31ab9eb047836933.woff2";


/*****************
 ** WEBPACK FOOTER
 ** ./src/styles/fonts/ikons/ikons.woff2
 ** module id = ./src/styles/fonts/ikons/ikons.woff2
 ** module chunks = 0
 **/